import { useCallback, useRef } from 'react';

interface UseScenarioTabsDragReturn {
  scenarioTabsRef: React.RefObject<HTMLDivElement | null>;
  handleTabsMouseDown: (e: React.MouseEvent<HTMLDivElement>) => void;
  shouldSuppressClick: () => boolean;
}

export type { UseScenarioTabsDragReturn };

export function useScenarioTabsDrag(): UseScenarioTabsDragReturn {
  const scenarioTabsRef = useRef<HTMLDivElement>(null);
  const tabsDragState = useRef({ isDragging: false, startX: 0, scrollLeft: 0, hasMoved: false });

  const handleTabsMouseDown = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    const el = scenarioTabsRef.current;
    if (!el) return;
    tabsDragState.current = { isDragging: true, startX: e.clientX, scrollLeft: el.scrollLeft, hasMoved: false };
    el.style.cursor = 'grabbing';

    const handleMouseMove = (ev: MouseEvent) => {
      const dx = ev.clientX - tabsDragState.current.startX;
      if (Math.abs(dx) > 3) tabsDragState.current.hasMoved = true;
      el.scrollLeft = tabsDragState.current.scrollLeft - dx;
    };
    const handleMouseUp = () => {
      tabsDragState.current.isDragging = false;
      el.style.cursor = '';
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  }, []);

  const shouldSuppressClick = useCallback(() => tabsDragState.current.hasMoved, []);

  return { scenarioTabsRef, handleTabsMouseDown, shouldSuppressClick };
}
